import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, reduxForm } from 'redux-form'
import { Card, CardHeader, CardBody, Row, Col, Button, Input, Label, Form, FormGroup, Alert, FormFeedback } from 'reactstrap'
import { validationHelper, normalizeHelper } from '../../../../common/helpers'
import { messages } from '../../../../common/constants'
import { toast } from 'react-toastify'
import { createStore, resetCreateStore } from '../../../../store/store/actions'
import { getUsers } from '../../../../store/user/actions'
import { MainLoader } from '../../../../components'

class StoreAdd extends Component {

    constructor(props) {
        super(props)

        this.onSubmit = this.onSubmit.bind(this);
        this.renderUsersField = this.renderUsersField.bind(this)
    }

    componentDidMount() {
        this.props.getUsers({ option: 'STORE', reset: true })
    }

    componentDidUpdate(prevProps) {
        this.checkStoreCreationSuccess(prevProps)
    }
    componentWillUnmount() {
        this.props.resetCreateStore();
    }
    checkStoreCreationSuccess(prevProps) {
        if (prevProps.store == null && this.props.store != null) {
            toast.success('Tienda creada satisfactoriamente')
            this.props.history.push('/administration/stores')
        }
    }

    onSubmit(values) {
        this.props.createStore(values)
    }

    renderInputField(field) {
        const { meta: { touched, error } } = field
        const hasError = touched && error ? true : false
        const labelClass = field.labelClass ? field.labelClass : 'mt-1'

        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label className={labelClass} >{field.label}</Label>
                </Col>
                <Col xs="12" md="5">
                    <Input {...field.input} invalid={hasError} type={field.type} placeholder={field.placeholder} />
                    {hasError == true ?
                        <FormFeedback>{error}</FormFeedback>
                        : null}
                </Col>
            </FormGroup>
        )
    }

    renderUserItems() {
        return this.props.users.map(user => {
            return (
                <option key={user.id} value={user.id}>{user.name}</option>
            )
        })
    }

    renderUsersField(field) {
        const { meta: { touched, error } } = field
        const hasError = touched && error ? true : false

        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label htmlFor="select">Usuario *:</Label>
                </Col>
                <Col xs="12" md="5">
                    <Input {...field.input} type="select" invalid={hasError} >
                        <option key={0} value={0}>Seleccione...</option>
                        {this.renderUserItems()}
                    </Input>
                    {hasError == true ?
                        <FormFeedback>{error}</FormFeedback>
                        : null}
                </Col>
            </FormGroup>
        )
    }

    render() {
        const { handleSubmit, usersLoading, loading, error } = this.props
        if (usersLoading) {
            return <MainLoader />
        }
        return (
            <div className='animated'>
                <Card>
                    <CardHeader>
                        Nueva Tienda
                    </CardHeader>
                    <CardBody>
                        {
                            error && (
                                <Alert color="danger">
                                    {error}
                                </Alert>
                            )
                        }
                        <Form onSubmit={handleSubmit(handleSubmit(this.onSubmit))} >
                            <Field name='name' label='Nombre:' type='text' component={this.renderInputField} />
                            <Field name='ruc' label='RUC:' type='text' component={this.renderInputField} normalize={normalizeHelper.numberOnlyField(11)} />
                            <Field name='businessName' label='Razón Social:' type='text' component={this.renderInputField} />
                            <Field name='address' label='Dirección:' type='text' component={this.renderInputField} normalize={normalizeHelper.noSpecialsField()} />
                            <Field name='longitude' label='Longitud' type='text' component={this.renderInputField} />
                            <Field name='latitude' label='Latitud' type='text' component={this.renderInputField} />
                            <Field name='phone' label='Teléfono:' type='text' component={this.renderInputField} normalize={normalizeHelper.numberOnlyField(9)} />
                            <Field name='openingHours' label='Horario de Atención:' placeholder="08:00 - 20:00" type='text' component={this.renderInputField} />
                            <Field name='user_id' component={this.renderUsersField} />
                            <Field name='username' label='Usuario Tienda Escontech (Facturación Electrónica): ' component={this.renderInputField} />
                            <Field name='password' label='Contraseña Tienda Escontech (Facturación Electrónica): ' type='password' component={this.renderInputField} />
                            <Field name='url' label='URL Ticket Impreso (Facturación Electrónica):' type='text' component={this.renderInputField} />
                            <Row>
                                <Col className='mt-3'>
                                    <Button type='submit' disabled={loading} color='primary' className='mr-2' ><i className="fa fa-save mr-1" /> Guardar</Button>
                                    <Button color='secondary' onClick={() => this.props.history.push('/administration/stores')} ><i className="fa fa-chevron-left mr-1" /> Cancelar</Button>
                                </Col>
                            </Row>

                        </Form>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

function validate(values) {
    const errors = {}

    if (validationHelper.stringIsNullOrEmpty(values.name)) {
        errors.name = messages.MANDATORY_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.ruc)) {
        errors.ruc = messages.MANDATORY_FIELD
    } else if (!validationHelper.isNumber(values.ruc, 11)) {
        errors.ruc = messages.RUC_FORMAT_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.businessName)) {
        errors.businessName = messages.MANDATORY_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.address)) {
        errors.address = messages.MANDATORY_FIELD
    }

    if (!values.longitude) errors.longitude = messages.MANDATORY_FIELD
    if (!values.latitude) errors.latitude = messages.MANDATORY_FIELD

    if (validationHelper.stringIsNullOrEmpty(values.phone)) {
        errors.phone = messages.MANDATORY_FIELD
    } else if (!validationHelper.isPhone(values.phone)) {
        errors.phone = messages.PHONE_FORMAT_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.url)) {
        errors.url = messages.MANDATORY_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.user_id) || values.user_id == "0") {
        errors.user_id = messages.MANDATORY_FIELD
    }

    if (validationHelper.stringIsNullOrEmpty(values.username)) {
        errors.username = messages.MANDATORY_FIELD
    }
    if (validationHelper.stringIsNullOrEmpty(values.password)) {
        errors.password = messages.MANDATORY_FIELD
    }

    return errors
}

function mapStateToProps(state) {

    const { store, loading, error } = state.store.newStore

    return {
        store,
        loading,
        error,
        users: state.user.userList.users,
        usersLoading: state.user.userList.loading,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        createStore,
        getUsers,
        resetCreateStore,
    }, dispatch)
}

export default reduxForm({
    form: 'StoreAddForm',
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: true,
    touchOnBlur: false,
    validate
})(
    connect(mapStateToProps, mapDispatchToProps)(StoreAdd)
)



// WEBPACK FOOTER //
// ./src/scenes/Administration/Store/StoreAdd/StoreAdd.js